import React from 'react'
import TitleAlt from '../TitleAlt'

const LinkImageShare = ({ LinkShare, ClassNameShare, ImageRed }) => (
    <a target="_blank" rel="noreferrer" href={LinkShare} className={`container-image-share ${ClassNameShare}`}>
        <img className={`image-share ${ClassNameShare}`} src={ImageRed} alt={TitleAlt}/>
    </a>
)

export default LinkImageShare
